import { authorizedApiClient } from "../config";
import {
  CreateExportRequest, DownloadExportParams, DownloadExportResponse,
  ExportResponse, GetExportParams, ListExportsParams, ListExportsResponse,
} from "./exportsEndpoints.interface";

/**
 * Create a new CSV export job.
 * Only one export per workspace can be processed at a time.
 * Returns 202 Accepted with the export details.
 */
export const createExport = async ({
  workspace_id,
  view_id,
}: { workspace_id: string } & CreateExportRequest) => authorizedApiClient.post<ExportResponse>(
  `/exports/${workspace_id}/exports`,
  { view_id },
);

/**
 * List CSV exports for the current user and workspace.
 */
export const listExports = async ({
  workspace_id,
  skip = 0,
  limit = 100,
}: ListExportsParams) => authorizedApiClient.get<ListExportsResponse>(
  `/exports/${workspace_id}/exports`,
  {
    params: { skip, limit },
  },
);

/**
 * Get a specific CSV export by ID.
 */
export const getExport = async ({
  workspace_id,
  id,
}: GetExportParams) => authorizedApiClient.get<ExportResponse>(
  `/exports/${workspace_id}/exports/${id}`,
);

/**
 * Download a CSV export file.
 * Generates a signed URL for downloading the file.
 * URL expires in 7 days (604800 seconds).
 */
export const downloadExport = async ({
  workspace_id,
  id,
}: DownloadExportParams) => authorizedApiClient.get<DownloadExportResponse>(
  `/exports/${workspace_id}/exports/${id}/download`,
);
